<template>
  <v-form ref="businessForm" v-model="valid">
    <v-layout style="width: 100%" row wrap>
      <v-flex xs12 pl-2>
        <v-flex pt-2 class="field-padding" row wrap>
          <h4 class="grey--text text--darken-1">Address Information</h4>
          <v-layout row wrap>
            <v-flex xs6 md4 px-2>
              <v-text-field
                :error-messages="errorForField('address1')"
                maxlength="100"
                :rules="businessRules.address1"
                v-model="business.address1"
                label="Address Line 1"
                @input="resetError('address1')"
                :disabled="disabled"
              />
            </v-flex>
            <v-flex xs6 md4 px-2>
              <v-text-field
                :error-messages="errorForField('address2')"
                maxlength="100"
                :rules="businessRules.address2"
                v-model="business.address2"
                label="Address Line 2"
                @input="resetError('address2')"
                :disabled="disabled"
              />
            </v-flex>
            <v-flex xs6 md4 px-2>
              <v-text-field
                :error-messages="errorForField('town')"
                maxlength="50"
                :rules="businessRules.town"
                v-model="business.town"
                label="Town"
                @input="resetError('town')"
                :disabled="disabled"
              />
            </v-flex>
            <v-flex xs6 md4 px-2>
              <v-text-field
                :error-messages="errorForField('county')"
                maxlength="50"
                :rules="businessRules.county"
                v-model="business.county"
                label="County"
                @input="resetError('county')"
                :disabled="disabled"
              />
            </v-flex>
            <v-flex xs6 md4 px-2>
              <v-text-field
                :error-messages="errorForField('postcode')"
                maxlength="8"
                :rules="businessRules.postcode"
                v-model="business.postcode"
                label="Postcode"
                @input="resetError('postcode')"
                :disabled="disabled"
              />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>
      <v-flex xs12 pl-2 pb-2>
        <v-flex pt-2 class="field-padding" row wrap>
          <h4 class="grey--text text--darken-1">Kiosk Information</h4>
          <v-layout row wrap>
            <v-flex xs6 md4 px-2>
              <v-text-field
                :error-messages="errorForField('kiosk_passcode')"
                maxlength="12"
                :rules="businessRules.kiosk_passcode"
                v-model="business.kiosk_passcode"
                label="Kiosk Passcode"
                @input="resetError('kiosk_passcode')"
                :disabled="disabled"
              />
            </v-flex>
            <v-flex v-if="disabled" xs6 md4 px-2>
              <v-text-field :disabled="disabled" label="Location" />
            </v-flex>
            <v-flex v-if="!disabled" xs6 md4 px-2 pt-1>
              <BookingLocationInput
                @locationChanged="locationUpdated"
                v-model="business.location"
                label="Default Pickup Location"
                id="favourite"
                :error="errorForField('location')"
                :singleLineField="false"
                :soloField="false"
                backgroundColour
                :rules="businessRules.location"
                :disabled="disabled"
              />
            </v-flex>
            <v-flex xs6 md4 px-2>
              <v-text-field
                :error-messages="errorForField('location_name')"
                maxlength="50"
                :rules="businessRules.location_name"
                v-model="business.location_name"
                label="Location Name (Pretty)"
                @input="resetError('location_name')"
                :disabled="disabled"
              />
            </v-flex>
            <v-flex xs6 md4 px-2>
              <v-select
                :error-messages="errorForField('default_payment_type')"
                :rules="businessRules.default_payment_type"
                v-model="business.default_payment_type"
                :items="paymentTypes"
                item-text="name"
                item-value="key"
                label="Default Payment Type"
                @input="resetError('default_payment_type')"
                :disabled="disabled"
              />
            </v-flex>
            <v-flex xs6 md4 pt-2 pl-5>
              <v-checkbox
                v-model="business.hotel"
                color="primary"
                label="Hotel"
                :disabled="disabled"
              />
            </v-flex>
            <v-flex xs6 md4 pt-2 pl-5>
              <v-checkbox
                v-model="business.sub_accounts_enabled"
                color="primary"
                label="Enable Sub-accounts"
                :disabled="disabled"
              />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
import BookingLocationInput from "@/components/widget/input/BookingLocationInput.vue";

export default {
  name: "business_form",
  components: {
    BookingLocationInput,
  },
  props: {
    business: Object,
    errors: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    paymentTypes: {
      type: Array,
      default: [],
    },
  },
  data: function () {
    return {
      valid: false,
      businessRules: {
        address1: [
          (v) =>
            (v || "").length <= 100 ||
            "First address line cannot exceed 100 characters",
        ],
        address2: [
          (v) =>
            (v || "").length <= 100 ||
            "Second address line cannot exceed 100 characters",
        ],
        town: [(v) => v.length <= 50 || "Town cannot exceed 50 characters"],
        county: [(v) => v.length <= 50 || "County cannot exceed 50 characters"],
        postcode: [
          (v) => v.length <= 8 || "Postcode cannot exceed 8 characters",
        ],
        kiosk_passcode: [
          (v) =>
            (v || "").length <= 12 ||
            "Kiosk passcode cannot exceed 12 characters",
        ],
        location_name: [
          (v) =>
            (v || "").length <= 100 ||
            "Location Name cannot exceed 100 characters",
        ],
        default_payment_type: [
          (v) => !!v || "Default payment type is required",
        ],
        location: [],
      },
    };
  },
  methods: {
    errorForField: function (field) {
      try {
        return this.errors[field];
      } catch (err) {
        return null;
      }
    },
    resetError: function (field) {
      try {
        if (this.errors[field] != "") {
          this.errors[field] = "";
        }
      } catch (err) {}
    },
    validateForm: function () {
      this.$refs.businessForm.validate();
    },
    locationUpdated: function (loc) {
      this.business.location = loc;
      this.resetError("location");
    },
  },
  watch: {
    valid: function () {
      this.$emit("validityChange", this.valid);
    },
  },
};
</script>

<style>
.noStepNumber input[type="number"] {
  -moz-appearance: textfield;
}
.noStepNumber input::-webkit-outer-spin-button,
.noStepNumber input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>